
import React from 'react';
import Layout from '../../components/Layout';
import SubNavBar from '../../components/SubNavBar/SubNavBar';
import BookingContainer from './BookingContainer';


function action({ store, params, query }) {
  const title = store.getState().siteSettings?.data?.siteTitle
  const description = store.getState().siteSettings?.data?.metaDescription;
  let isAuthenticated = store.getState().runtime.isAuthenticated;
  const preferredCurrency = store.getState().userAccount?.data?.preferredCurrency;

  const type = params.type

  if (!isAuthenticated) {
    return { redirect: '/' }
  }
  return {
    title,
    description,
    component: (
      <Layout>
        <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
          {isAuthenticated && <SubNavBar />}
          <BookingContainer preferredCurrency={preferredCurrency} type={type} />
        </div>
      </Layout>
    ),
  };
}

export default action;
